import { hideSpinner } from './spinnerActions';

export const initializeSettingsPage = () => async dispatch => dispatch(hideSpinner());